import {
  dbui_v1_DismissOperationalAlertsRequest,
  dbuiV1DismissOperationalAlertsMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
export const useDismissAlerts = () => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';

  return useMutation({
    mutationFn: (data: dbui_v1_DismissOperationalAlertsRequest) =>
      dbuiV1DismissOperationalAlertsMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: { ...data, warehouse }, path: { workspace } }),
  });
};
